const FeatureNames = Object.freeze({
    STUDY: 'studies',
});

export default FeatureNames;
